import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import * as evaluacionService from "../../services/evaluacionService";
import { Grid, Card, CardContent, Snackbar, Alert } from '@mui/material';
import Evaluacion from '../../components/Evaluacion'
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from '../../hooks/useMantenimiento';
import { activeValidations as activeValidationsEvaluacion, setEntity, setEvaluacionDetalle } from '../../redux/evaluacionDetalleSlice';

// Mantenimiento de la evaluacion: la cabecera y el detalle de los temas.
const Edit = () => {
    const idFilialUsuario = useSelector((state) => state.seguridad?.idFilial) || 0;
    const evaluacion = useSelector((state) => state.evaluacionDetalle.entity);
    const evaluacionValidation = useSelector((state) => state.evaluacionDetalle.validationMessage);
    const defaultEvaluacionDetalle = useSelector((state) => state.evaluacionDetalle.defaultEntity)

    const [openMessage, setOpenMessage] = useState(false)
    const onCloseMessage = () => { setOpenMessage(!openMessage); }
    const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();
    const { isReadOnly, setIsReadOnly } = useMantenimiento("evaluacion");

    const mensaje = (severity, texto) => {
        setPropsMessage({ severity: severity, message: texto })
        setOpenMessage(true);
    }

    // Guarda la evaluacion y despues su detalle, que necesita el id.
    const postEntity = async () => {
        if (evaluacionValidation.length > 0) {
            dispatch(activeValidationsEvaluacion());
            mensaje("error", evaluacionValidation.join(" - "))
            return;
        }

        try {
            const response = await evaluacionService.addUpdateEvaluacion({
                id: evaluacion.id,
                idFilial: evaluacion.idFilial || (idFilialUsuario > 0 ? idFilialUsuario : 1),
                idParticipante: evaluacion.idParticipante,
                fecha: evaluacion.fecha,
                idResponsable: evaluacion.idResponsable,
                idTipo: evaluacion.idTipo,
                idEstado: evaluacion.idEstado,
                observaciones: evaluacion.observaciones,
                evaluacionDetalle: (evaluacion.evaluacionDetalle || [])
                    .filter((fila) => fila.idTema > 0)
                    .map((fila) => ({
                        idTema: fila.idTema,
                        resultado: fila.resultado,
                        observaciones: fila.observaciones,
                    })),
            })
            mensaje("success", "Se guardaron los datos con exito")
            setIsReadOnly(true)

            // Se recarga lo que se grabo, igual que al editar: la cabecera
            // desde el listado del participante y el detalle con los ids ya
            // generados. En una evaluacion nueva la cabecera se busca en ese
            // listado porque recien ahi aparece con su id.
            const id = response.data.data;

            const lista = await evaluacionService.getsEvaluacionView(evaluacion.idParticipante)
                .catch(() => []);

            const guardada = (lista || []).find((row) => row.id == id);

            if (guardada != null) dispatch(setEntity(guardada));

            const detalle = await evaluacionService.getsEvaluacionDetalleView(id)
                .catch(() => []);

            dispatch(setEvaluacionDetalle((detalle || []).map((row, indice) => ({ ...row, numero: indice + 1 }))))

            // La direccion queda con el id real, sin recargar la pagina: si
            // mas tarde se recarga a mano, la evaluacion se vuelve a mostrar.
            if (evaluacion.id == 0) {
                navigate("/evaluacion/edit/" + id + "/" + evaluacion.idParticipante, { replace: true });
            }
        }
        catch (err) {
            console.log("Err: ", err);
            mensaje("error", "Hubo un error al guardar")
        }
    }

    return (
        <div>
            <MantenimientoForm
                title={(parseInt(params.id) === 0 ? "Nuevo" : "Editar") + " Evaluacion"}
                backTo={"/evaluacion/" + (params.idParticipante || 0)}
                onSave={postEntity}
                disabled={isReadOnly}
            >
                <Grid container spacing={1} sx={{
                    "& .MuiGrid-root>.MuiGrid-item": {
                        paddingTop: "8px"
                    },
                }}>
                    <Grid item xs={12} sm={12}>
                        <Card>
                            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                                <Evaluacion isReadOnly={isReadOnly} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </MantenimientoForm>
            <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
                    {propsMessage.message}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default Edit
